// extracted by mini-css-extract-plugin
export default {"iframe":"cJ3l5"};